import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserProfile } from '../models/user-profile.model';
import { BEARER_ONLY, BYPASS_HEAD } from '../interceptor/token.interceptor';
@Injectable({
  providedIn: 'root',
})
export class AccountService {

  constructor(
    private http: HttpClient
  ) { }

  userProfile(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + 'api/v1/mobile/user/details');
  }
  changePassword(item: any): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `api/v1/mobile/user/change-password`, JSON.stringify(item),{withCredentials: true});
  }

  getDocumentList(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/mobile/document/list');
  }

  getQrList(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/mobile/getpass/qrs');
  }
}
